import { PRACTITIONER, PRACTITIONER_PHOTO, INSURANCE } from "@/data/content";
import BookingButton from "./BookingButton";

export default function About() {
  return (
    <section id="about" className="py-28 lg:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="sticky top-32">
            <img
              src={PRACTITIONER_PHOTO}
              alt={PRACTITIONER.name}
              className="w-full h-[640px] object-cover object-center rounded-sm"
              data-testid="about-image"
            />
            <div className="mt-4 eyebrow">{PRACTITIONER.title}</div>
            <div className="font-serif-display text-2xl mt-1">{PRACTITIONER.name}</div>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <div className="eyebrow mb-4">03 · About</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight mb-8">
            We listen, act, and transform.
          </h2>

          <p className="text-lg leading-relaxed mb-6" style={{ color: "var(--sano-ink-2)" }}>
            {PRACTITIONER.oneLiner}
          </p>

          {PRACTITIONER.bio.map((para, i) => (
            <p key={i} className="text-base leading-relaxed mb-5" style={{ color: "var(--sano-ink-2)" }}>
              {para}
            </p>
          ))}

          <div className="mt-10 grid grid-cols-2 gap-8 pt-8 border-t" style={{ borderColor: "var(--sano-border)" }}>
            <div>
              <div className="eyebrow mb-2">Specialties</div>
              <div className="font-serif-display text-xl leading-tight">
                Pain relief<br/>Nervous system regulation<br/>Facial acupuncture<br/>Yoni steam therapy
              </div>
            </div>
            <div>
              <div className="eyebrow mb-2">Licensed in</div>
              <div className="font-serif-display text-xl leading-tight">
                New York State
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t" style={{ borderColor: "var(--sano-border)" }}>
            <div className="eyebrow mb-4">Insurance accepted</div>
            <div className="flex flex-wrap gap-2">
              {INSURANCE.map((p) => (
                <span
                  key={p}
                  className="px-3 py-1.5 border text-xs"
                  style={{ borderColor: "var(--sano-border)", background: "var(--sano-bg-2)" }}
                  data-testid={`insurance-${p.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <BookingButton testid="about-book-btn" label="Book with Joannie" />
          </div>
        </div>
      </div>
    </section>
  );
}
